import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as _ from 'lodash';
import { ZoningCode } from 'src/app/modules/instance/models';
import { ZoningCodeService } from 'src/app/modules/instance/services';

@Component({
    standalone: false,
    selector: 'app-typology-subform',
    templateUrl: './typology-subform.component.html',
    styleUrls: ['./typology-subform.component.scss']
})
export class TypologySubformComponent implements OnInit {
    @Output()
    formReady = new EventEmitter<FormGroup>();
    public typologies: any = [];
    public typologyForm: FormGroup;
    public zoningCodes: Array<ZoningCode>;

    public selectedAll: boolean;

    constructor(private formBuilder: FormBuilder, private readonly zoningCodeService: ZoningCodeService) {}

    get hasTypologies() {
        return this.typologies && !!this.typologies.length;
    }

    static getQueryParams(formGroup: any): any {
        return {
            selectedTypologies: formGroup['selectedTypologies'],
            zoningCodeId: formGroup['zoningCode'] && formGroup['zoningCode'].Id
        };
    }

    onChange(zoningCode: ZoningCode) {
        this.zoningCodeService.getTypologiesByZoningCodeId(zoningCode.Id).subscribe(response => {
            this.typologies = response.data.map(x => x);
            this.hasTypologies
                ? this.typologyForm.get('selectedTypologies').enable()
                : this.typologyForm.get('selectedTypologies').disable();
        });
    }

    selectAll() {
        this.selectedAll = !this.selectedAll;
        this.typologyForm.get('selectedTypologies').patchValue(this.selectedAll ? this.typologies : []);
    }

    ngOnInit() {
        this.zoningCodes = this.zoningCodeService.lastZoningCodesValue;
        this.typologyForm = this.formBuilder.group({
            selectedTypologies: [],
            zoningCode: ''
        });
        this.formReady.emit(this.typologyForm);
        this.typologyForm.get('selectedTypologies').disable();
    }
}
